<template>
  <span
    class="togglable-caret-header"
    v-bind="delegatedAttrs"
    @click="onHeaderClick"
  >
    <font-awesome-icon
      v-if="showCaret"
      :icon="['fas', icon]"
      class="mr-md-2 mr-2"
    />
    <slot />
  </span>
</template>
<script>
import { Collapse } from 'bootstrap';

const CARET_RIGHT = 'caret-right';
const CARET_DOWN = 'caret-down';

export default {
  name: 'togglable-caret-header',
  inheritAttrs: false,
  props: {
    showCaret: {
      type: Boolean,
      default: true,
    },
    /** When true, header does not toggle collapse (e.g. route forces section open). */
    collapseDisabled: {
      type: Boolean,
      default: false,
    },
    /** Optional explicit selector; otherwise `data-bs-target` from attrs is used. */
    collapseTarget: {
      type: String,
      default: '',
    },
    /** Initial / bound caret state when not using a collapse target. */
    open: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isExpanded: false,
    };
  },
  computed: {
    icon() {
      return this.isExpanded ? CARET_DOWN : CARET_RIGHT;
    },
    delegatedAttrs() {
      const { 'data-bs-toggle': _omitToggle, ...rest } = this.$attrs;
      return rest;
    },
    collapseSelector() {
      if (this.collapseTarget) return this.collapseTarget;
      const t = this.$attrs['data-bs-target'];
      return typeof t === 'string' ? t : '';
    },
  },
  watch: {
    open: {
      immediate: true,
      handler(val) {
        if (this.collapseDisabled) {
          this.isExpanded = true;
          return;
        }
        if (!this.collapseSelector) {
          this.isExpanded = !!val;
        }
      },
    },
    collapseDisabled: {
      immediate: true,
      handler(val) {
        if (val) this.isExpanded = true;
      },
    },
  },
  mounted() {
    this.syncFromCollapseEl();
  },
  methods: {
    syncFromCollapseEl() {
      if (this.collapseDisabled) {
        this.isExpanded = true;
        return;
      }
      const sel = this.collapseSelector;
      if (!sel) {
        return;
      }
      const el = document.querySelector(sel);
      if (el) {
        this.isExpanded = el.classList.contains('show');
      }
    },
    onHeaderClick() {
      if (this.collapseDisabled) {
        return;
      }
      const sel = this.collapseSelector;
      if (!sel) {
        this.isExpanded = !this.isExpanded;
        return;
      }
      const el = document.querySelector(sel);
      if (!el) {
        return;
      }
      Collapse.getOrCreateInstance(el).toggle();
      this.$nextTick(() => {
        this.isExpanded = el.classList.contains('show');
      });
    },
  },
};
</script>
<style scoped lang="scss">
</style>
